// Things kept in the browser outside the plan document are filed by owner: an
// account's id, or the device when nobody is signed in. Filed any other way,
// the next person to use the browser sees them.

export const DEVICE_OWNER = 'device';

// The real estate form and the saved property comparison.
export const OWNED_KEYS = ['ultronic_real_estate_form', 'ultronic_property_comparison'];

const keyFor = (base, owner) => `${base}:${owner}`;

export function readOwned(base, owner) {
  try {
    // Saved before owners existed: like the device plan, it goes to whoever
    // opens the app first and does not stay behind for anyone else.
    const unfiled = localStorage.getItem(base);
    if (unfiled != null) {
      if (localStorage.getItem(keyFor(base, owner)) == null) localStorage.setItem(keyFor(base, owner), unfiled);
      localStorage.removeItem(base);
    }
    const saved = localStorage.getItem(keyFor(base, owner));
    return saved ? JSON.parse(saved) : null;
  } catch {
    return null;
  }
}

export function writeOwned(base, owner, value) {
  try {
    localStorage.setItem(keyFor(base, owner), JSON.stringify(value));
  } catch {
    // Storage full or unavailable: these are conveniences, not the plan.
  }
}

export function removeOwned(base, owner) {
  try {
    localStorage.removeItem(keyFor(base, owner));
  } catch {
    // Nothing to remove.
  }
}
